'use strict';
(function (angular) {
	const template = `
<div class="pmt-ui-status-bar pmt-ui-status-bar--symbol pmt-ui-status-bar--{{$ctrl.className}}">
	<span class="pmt-ui-status-bar__message" ng-transclude></span>
</div>`;

	function Controller() {
		this.rootClasses = [];

		this.$onInit = () => {
			const classNames = {
				success: 'success',
				warning: 'warning',
				error: 'danger'
			};
			this.className = classNames[this.type] || 'status';
		};
	}

	angular.module('PinMeTo.UI').component('pmtUiStatusBar', {
		template: template,
		transclude: true,
		bindings: {
			type: '@'
		},
		controller: Controller
	});

	Controller.$inject = [];
})(window.angular);
